import React from 'react';
import { MapPin, MessageCircle } from 'lucide-react';
import { CONTACT, SEDES_IMAGES } from './Constants';
import { SedeCarousel } from './SedeCarousel';
export function SedesSection() {
  const sedes = [{
    images: SEDES_IMAGES.polpaico,
    title: 'Sede Polpaico, Til-Til',
    text: 'Rodeada de entornos naturales, ideal para desconectarse del estrés y enfocarse en la recuperación emocional.'
  }, {
    images: SEDES_IMAGES.naltahua,
    title: 'Sede Naltahua, Isla de Maipo',
    text: 'Cuenta con áreas verdes y espacios de reflexión que promueven serenidad y bienestar.'
  }, {
    images: SEDES_IMAGES.olea,
    title: 'Sede Olea, Isla de Maipo',
    text: 'Ubicada en una parcela tranquila, con espacios adecuados para el abordaje personal y grupal.'
  }, {
    images: SEDES_IMAGES.femenina,
    title: 'Sede Femenina',
    text: 'Diseñada para brindar una experiencia segura, cómoda y confiable para cada residente.'
  }];
  return <section id="sedes" className="py-16 md:py-24 bg-graySoft" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-bold text-azul mb-6" data-id="element-218">
            Conoce nuestros centros
          </h2>
          <p className="text-lg text-gray-600" data-id="element-219">
            Contamos con sedes ubicadas en entornos tranquilos y naturales,
            pensadas para entregar un ambiente seguro, cómodo y adecuado para el
            acompañamiento terapéutico.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-220">
          {sedes.map((sede, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-221">
              <SedeCarousel images={sede.images} alt={sede.title} data-id="element-222" />
              <div className="p-6" data-id="element-223">
                <div className="flex items-center mb-3" data-id="element-224">
                  <MapPin className="w-5 h-5 text-celeste mr-2" data-id="element-225" />
                  <h3 className="text-xl font-semibold text-azul" data-id="element-226">
                    {sede.title}
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-227">{sede.text}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-228">
          <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 border border-transparent rounded-full shadow-md text-base font-semibold text-white bg-whatsapp hover:bg-whatsapp-hover transition-colors" data-id="element-229">
            <MessageCircle className="w-5 h-5 mr-2" data-id="element-230" />
            Solicitar orientación por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}